<template>
  <router-link v-bind="$props" :to="computedTo">
    <slot />
  </router-link>
</template>

<script setup lang="ts">
  import {RouterLink} from 'vue-router';
  import {computed} from 'vue';
  import {getPrefixedTo} from '@console/helpers/router';

  const props = defineProps({
    // @ts-ignore
    ...RouterLink.props,
  });

  const computedTo = computed(() => getPrefixedTo(props.to));
</script>

<style scoped></style>
